// / — the homepage, on the same template as the solution pages
// (SolutionLanding): the navy hero with the voice drill, one segment grid that
// opens each training page, the platform strip, then the personal workspace
// itself — Scenarios, Library, a debrief, Reviews and Progress, recreated in
// WorkspaceScenes — and the closing call to action. Copy lives in
// i18n/homeLandingPage.ts.
import { useProductSeo } from "@/shared/hooks/useProductSeo";
import { useT } from "@/shared/i18n/useT";
import { SolutionLanding } from "@/shared/pages/solutions/SolutionLanding";
import { SegmentGrid } from "@/shared/pages/solutions/SegmentGrid";
import { LiveDrill } from "@/shared/pages/solutions/CrisisLiveDrill";
import {
  WorkspaceCatalogScene,
  WorkspaceDebriefScene,
  WorkspaceLibraryScene,
  WorkspaceProgressScene,
  WorkspaceReviewsScene,
} from "@/shared/pages/solutions/WorkspaceScenes";
import heroArtwork from "@/shared/assets/images/geometryofagreement.jpg";

const K = "homeLanding";

/** The workspace, page by page, each with its recreated screen. */
const SCENES = [
  ["scenarios", WorkspaceCatalogScene],
  ["materials", WorkspaceLibraryScene],
  ["debrief", WorkspaceDebriefScene],
  ["reviews", WorkspaceReviewsScene],
  ["progress", WorkspaceProgressScene],
] as const;

const FACTS = ["voice", "emery", "instructor", "share"] as const;

export function HomePage() {
  useProductSeo("home");
  const t = useT();
  return (
    <SolutionLanding
      k={K}
      signupPath="/signup"
      scenarioPath="/scenarios/crisis-eviction-barricade"
      demoPath="/contact"
      artwork={heroArtwork}
      proof={
        <div className="flex items-center gap-3.5">

        </div>
      }
      visual={<LiveDrill t={t} />}
      heroLink={{ href: "/demo", label: t(`${K}.hero.workspaceDemo`) }}
      afterHero={<SegmentGrid />}
      facts={FACTS}
      scenes={SCENES}
      explore={[
        { href: "/products/api", label: t(`${K}.final.api`) },
        { href: "/blog", label: t(`${K}.final.blog`) },
      ]}
    />
  );
}
